import Vue from 'vue';
import store from 'store/mainStore';
import 'es6-promise/auto';
import 'quasar/dist/quasar.umd.min';

(function(wv, undefined){
	wv.store = store;
	wv.eventAll = new Vue({
		el: "#eventAllContainerWrapper",
		store,
		components: {
			'event-all-main': () => import(/* webpackPrefetch: true */ 'components/eventAll/eventAllMain'),
			// 'event-all-main': () => import(/* webpackPrefetch: true */ 'components/eventAll/eventTileDisplayTemplate'),
		},
	});
}( window.wv = window.wv || {} ));